/*
* @Author: abhishek714
* @Date:   2025-05-29 12:05:59
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-09-17 10:32:06
*/
export const INDEX_URL = '/portal/';
export const SITE_URL = '/';
export const API_URL = 'https://admin.techtopind.com/api/';
export const REP_API_URL = 'https://admin.techtopind.com/rep-portal-api/';
export const EXTERNAL_API_URL = 'https://admin.techtopind.com/external-api/';
export const SITE_TITLE = 'TECHTOP Electric Motors';